import { RuntimeEngine } from '@easytwin/runtime';
import { useMainScene } from './useMainScene';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';

export const useIsSceneInited = (engine: RuntimeEngine | undefined) => {
  const scene = useMainScene(engine);
  const refresh = useDumbState();

  useBindSignal(scene?.signals.sceneUpdated, refresh);

  return scene?.isInited;
};
